module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAGMAAABjBAMAAAB9FaOmAAAAHlBMVEX////oES3qJ0DwYXToFTDpGzb60NbyeIj83OHtRly4PaehAAAAiklEQVR4Ae3WtQECQRQE0I8T/ulgNyOEDqADvA7oBCrG9dx1Jr53tjbiGTyj4h0SEpJqEkCDCaClEBtOjIPMMA8mC0zlJx084ybuCypP9nKEGVt/MhGLw3AlvzmH/+RT8qGsNuHarx5B3GgzCAkJtws2pQJIgnM/QbtoVrlK0C2TNVg2JRISkuzJFfFrdWThWPZSAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/uis/assets/images/flags/Georgia.png
// module id = 575
// module chunks = 0